<template>

    <a :id="`jump-to-` + injectedQuiz.id"></a>
    <component
        v-if="ready"
        :is="currentComponent"
        @show-screen="onChangeScreen"
        @jump-to-top="jumpToTop"
    />

</template>


<script>
export default {
    name       : 'Quiz Module',
    components : [],
}
</script>


<script setup>
import {
    computed,
    ref,
    onMounted,
    reactive,
    inject,
    getCurrentInstance,
    nextTick,
}                             from "vue";
import { storeKey, useStore } from "vuex";
import Quiz                   from './Quiz.vue';
import Results                from './Results.vue';
import { getElementOffset }   from '../../Utils';

//init
let store                   = useStore();
const injectedQuiz          = inject( 'quiz' );
const injectedCopydeck      = inject( 'copydeck' );
const injectedQuizReactions = inject( 'quizReactions' );
const injectedQuizContainer = inject( 'quizContainer' );

console.log( "injectedQuiz", injectedQuiz );

//COMPUTED
let ready               = computed( () => store.state.ready );
let screen              = ref( null );
let availableComponents = ref( { "quiz" : Quiz, "results" : Results } );
let currentComponent    = ref( null );


//methods


function onChangeScreen ( newScreen )
{
    screen.value           = newScreen;
    currentComponent.value = availableComponents.value[ screen.value ];
}

function jumpToTop ()
{


    let url       = location.href;
    location.href = "#" + `jump-to-${injectedQuiz.id}`;
    history.replaceState( null, null, url );


    const quizContainer = document.querySelector( '#' + injectedQuizContainer.id );
    if ( quizContainer )
    {
        const top = getElementOffset( quizContainer ).top - document.querySelector( '#site-header' ).getBoundingClientRect().height - 10;
        window.scrollTo( 0, top, 'smooth' );
    }
}

async function mounted ()
{

    //await store.dispatch( "copydeck" );

    if ( !injectedQuiz )
    {
        console.error( 'No data defined for this quiz' );
        return;
    }

    store.commit( 'copydeck', injectedCopydeck );
    store.commit( 'quiz', injectedQuiz );
    store.commit( 'quizReactions', injectedQuizReactions );

    store.commit( "ready" );

    onChangeScreen( "quiz" );

}

onMounted( mounted );

</script>

<style scoped>

</style>
